// components/ResumeSyncer.js
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserProfile, fetchUserProfile } from '../../redux/AuthSlice/authSlice';

const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const [month, year] = dateStr.split('/');
    return new Date(`${year}-${month.padStart(2, '0')}-01`);
};

const ResumeSyncer = () => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { resumeData } = useSelector((state) => state.resume);
    const [synced, setSynced] = useState(false);

    useEffect(() => {
        if (resumeData) {
            setSynced(false);
        }
    }, [resumeData]);

    useEffect(() => {
        if (!resumeData?.education || synced || !user) return;

        const currentEducation = user.education || [];
        const currentExperience = user.experience || [];

        const newUniqueEdu = resumeData.education.filter((resumeEntry) =>
            resumeEntry.school && resumeEntry.degree && resumeEntry.field &&
            !currentEducation.some((existing) =>
                existing.school === resumeEntry.school &&
                existing.degree === resumeEntry.degree &&
                existing.field === resumeEntry.field
            )
        );

        const newUniqueExp = (resumeData.experience || [])
            .filter((resumeEntry) =>
                resumeEntry.company && resumeEntry.title &&
                !currentExperience.some((existing) =>
                    existing.company === resumeEntry.company &&
                    existing.title === resumeEntry.title &&
                    existing.startingDate === parseDate(resumeEntry.startingDate)?.toISOString()
                )
            )
            .map((entry) => ({
                ...entry,
                startingDate: parseDate(entry.startingDate),
                endingDate: entry.stillWorking ? null : parseDate(entry.endingDate)
            }));

        if (newUniqueEdu.length > 0 || newUniqueExp.length > 0) {
            const updatedData = {};
            if (newUniqueEdu.length > 0) {
                updatedData.education = [...currentEducation, ...newUniqueEdu];
            }
            if (newUniqueExp.length > 0) {
                updatedData.experience = [...currentExperience, ...newUniqueExp];
            }

            dispatch(updateUserProfile(updatedData)).then(() => {
                dispatch(fetchUserProfile());
                setSynced(true);
            });
        } else {
            setSynced(true);
        }

        if (newUniqueExp.length === 0) {
            console.log("No new experience to sync.");
        }
    }, [resumeData, user, synced, dispatch]);

    return null;
};

export default ResumeSyncer;
